import React from 'react';
import {
    Image,
    View,
    Text,
    Linking,
    StyleSheet,
    ScrollView,
    ImageBackground,
    TouchableOpacity,
    ToastAndroid,
    ActivityIndicator
} from 'react-native';

import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledButton from '../../components/StyledButton';
import GenericModal from '../../components/modals/GenericModal';
import StyledIcon from '../../components/StyledIcon';
import { AuthContext } from '../../contexts/auth/Store';
import { useNavigation } from '@react-navigation/native';
import { AnalyticsService } from '../../constants/Analytics';
import WalletNavCard from '../../components/wallet/NavCard';
import WalletHistoryCard from '../../components/wallet/HistoryCard';
// import OTPInputView from '@twotalltotems/react-native-otp-input'
import GenericHeader from '../../components/headers/GenericHeader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import http from '../../utils/http';

const analytics = new AnalyticsService

function WalletPasscodeScreen() {
    const navigation = useNavigation()

    const auth = React.useContext(AuthContext)
    const token = auth.getUserData.userToken
    const buyer = auth.getUserData.buyerData

    const [countdown, setCountdown] = React.useState(null)

    const passcodeSchema = Yup.object().shape({
        passcode: Yup.string()
            .matches(/^\d{6}$/, 'OTP is invalid')
            .required('Enter OTP'),
    });

    const verifyPasscode = (values, actions) => {
        // mobile:07035062878
        // model:buyer
        // passcode:022927
        const form = new FormData()
        form.append('mobile', buyer.phone)
        form.append('model', 'buyer')
        form.append('passcode', values?.passcode)

        http.post('spend/eyowo_verify_otp', form, token)
            .then(res => {
                if (res.code === 200 && res?.data?.data?.accessToken) {
                    // ToastAndroid.show(res.data.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setSubmitting(false)
                    actions.resetForm()
                    navigation.navigate('WalletIndex')
                } else {
                    // // ToastAndroid.show(res.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                    actions.setFieldError('passcode', res.message)
                    actions.setSubmitting(false)
                }
            })
            .catch(err => {
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
                actions.setSubmitting(false)
                console.warm(err)
            })
    }

    const resendOTP = () => {
        setCountdown(60)
        let form = new FormData()
        form.append('mobile', buyer.phone)
        form.append('model', 'buyer')
        http.post('spend/eyowo_user_authenticate', form, token)
            .then(res => {
                if (res.code === 200 && res?.data?.success && res?.data?.message) {
                    // display message if so desired
                    // ToastAndroid.show(res.data.message, ToastAndroid.LONG, ToastAndroid.BOTTOM)
                } else {
                    console.warn(res)
                }
            })
            .catch(err => {
                console.warn(err)
                // ToastAndroid.show('An error occured.', ToastAndroid.LONG, ToastAndroid.BOTTOM)
            })
    }

    React.useEffect(() => {
        const timer = setTimeout(() => {
            if (countdown > 0) {
                setCountdown(countdown - 1)
            }
        }, 1000)
        return () => clearTimeout(timer)
    }, [countdown])

    React.useEffect(() => {
        navigation.addListener('focus', () => {
            if (navigation.isFocused()) {
                setCountdown(60)
                analytics.logEvent('Viewed Wallet OTP', buyer)
                analytics.googleHelpers.setCurrentScreen('ViewedWalletOTP', 'ViewedWalletOTP')
            }
        })
        return () => {
            // cleanup
            navigation.removeListener('focus')
        };
    }, []);

    return (
        <>
            <GenericHeader title="OTP Verification" />
            <ScrollView contentContainerStyle={styles.container}>
                <Formik
                    initialValues={{
                        passcode: ''
                    }}
                    validationSchema={passcodeSchema}
                    onSubmit={(values, actions) => verifyPasscode(values, actions)}
                >
                    {({ values, setFieldValue, errors, isSubmitting, isValid, submitForm }) => <View style={{ alignItems: 'center' }}>
                        <View style={styles.starWrapper}>
                            <Image source={require('../../assets/images/main/otp-star.png')} style={styles.star} />
                            <Image source={require('../../assets/images/main/otp-star.png')} style={styles.star} />
                            <Image source={require('../../assets/images/main/otp-star.png')} style={styles.star} />
                            <Image source={require('../../assets/images/main/otp-star.png')} style={styles.star} />
                        </View>
                        <View style={{ alignItems: 'center' }}>
                            <Text style={[FontStyles.normal, FontStyles.size15, FontStyles.lh22, FontStyles.dark, { marginTop: 26 }]}>Enter the OTP sent to</Text>
                            <Text style={[FontStyles.medium, FontStyles.size15, FontStyles.lh22, FontStyles.dark]}>{buyer.phone}</Text>
                        </View>
                        {/* <OTPInputView
                            pinCount={6}
                            style={{ width: '75%', height: 40, alignSelf: 'center', marginTop: 30 }}
                            code={values.passcode}
                            onCodeChanged={code => setFieldValue('passcode', code)}
                            codeInputFieldStyle={[FontStyles.size20, FontStyles.lh22, FontStyles.dark, {
                                borderRadius: 4,
                                backgroundColor: Colors.shades._5,
                                borderBottomWidth: 2
                            }]}
                            codeInputHighlightStyle={[FontStyles.default, {
                                backgroundColor: Colors.whiteColor
                            }]}
                        /> */}
                        {errors.passcode
                            ? <View style={{ alignSelf: 'center', marginTop: 30, width: 270 }}>
                                <Text style={[FontStyles.normal, FontStyles.size15, FontStyles.lh22, { textAlign: 'center', color: Colors.dangerText }]}>The OTP you entered is invalid. Please enter the correct OTP</Text>
                            </View>
                            : null
                        }
                        <StyledButton
                            label="Verify & Proceed"
                            color={isValid ? 'default' : 'light'}
                            size="sm"
                            style={{ marginTop: 30 }}
                            submitting={isSubmitting}
                            disabled={!isValid}
                            action={submitForm} />

                        <View style={{ flexDirection: 'row', justifyContent: 'center', marginTop: 20 }}>
                            <Text style={[FontStyles.normal, FontStyles.size15, FontStyles.lh22, { textAlign: 'center', color: Colors.greyColor, marginRight: 6 }]}>Didn’t receive pin?</Text>
                            {countdown < 1
                                ? <TouchableOpacity onPress={resendOTP}>
                                    <Text style={[FontStyles.normal, FontStyles.size15, FontStyles.lh22, { textAlign: 'center', color: Colors.darkColor }]}>Resend OTP</Text>
                                </TouchableOpacity>
                                : <Text style={[FontStyles.normal, FontStyles.size15, FontStyles.lh22, { textAlign: 'center', color: Colors.darkColor }]}>Resend in {countdown}s...</Text>
                            }
                        </View>
                    </View>}
                </Formik>
            </ScrollView>
        </>
    )
}

export default WalletPasscodeScreen

const styles = StyleSheet.create({
    container: {
        flexGrow: 1,
        backgroundColor: Colors.whiteColor,
    },
    starWrapper: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', marginTop: 58 },
    star: { width: 24, height: 28, marginHorizontal: 4 },
})